import styled from 'styled-components';
import { variant } from 'styled-system';
import css from '@styled-system/css';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { zIndex, color } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
var modalWrapperScrollBehavior = variant({
  prop: "scrollBehavior",
  variants: {
    inside: {
      overflow: "hidden"
    },
    outside: {
      overflow: "auto",
      alignItems: "flex-start"
    }
  }
});
var Wrapper = styled(Box).withConfig({
  componentId: "kwytcp-0"
})(["position:fixed;top:0;left:0;width:100%;height:100%;max-height:100dvh;display:flex;justify-content:center;align-items:", ";outline:0;z-index:", ";", ";"], function (_ref) {
  var isCentered = _ref.isCentered;
  return isCentered ? "center" : "flex-start";
}, zIndex("modal"), modalWrapperScrollBehavior);
var styles = css({
  boxShadow: 2,
  margin: ["sm", "sm", "md", "xl"],
  borderRadius: "base"
});
var modalSizes = variant({
  prop: "size",
  variants: {
    sm: {
      width: "360px"
    },
    md: {
      width: "540px"
    },
    lg: {
      width: "920px"
    }
  }
});
var modalFullsize = variant({
  prop: "scrollBehavior",
  variants: {
    inside: {
      height: "100%",
      maxHeight: [null, "calc(100% - 16px)", "calc(100% - 32px)", "calc(100% - 48px)"],
      width: "100%",
      maxWidth: [null, "calc(100% - 16px)", "calc(100% - 32px)", "calc(100% - 48px)"]
    },
    outside: {
      minHeight: [null, "calc(100% - 16px)", "calc(100% - 32px)", "calc(100% - 48px)"],
      width: "100%",
      maxWidth: [null, "calc(100% - 16px)", "calc(100% - 32px)", "calc(100% - 48px)"]
    }
  }
});
var modalScrollBehavior = variant({
  prop: "scrollBehavior",
  variants: {
    inside: {
      maxHeight: ["calc(100dvh - 16px)", "calc(100dvh - 32px)", "calc(100dvh - 48px)", "90dvh"]
    },
    outside: {}
  }
});
var Modal = styled(Box).withConfig({
  componentId: "kwytcp-1"
})(["position:relative;color:", ";display:flex;flex-direction:column;width:100%;outline:none;z-index:", ";", ";", ";", ";"], color("text.base"), zIndex("modal"), styles, function (props) {
  return props.isFull ? modalFullsize : modalSizes;
}, modalScrollBehavior);
export { Modal, Wrapper };